import { Injectable } from '@angular/core';
import { LocalStorageKey } from 'src/app/utils';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setItem(key: LocalStorageKey, value: any): void {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: LocalStorageKey): any {
    let value = window.localStorage.getItem(key);
    if (value === null) {
      return null;
    }

    return JSON.parse(value);
  }

  removeItem(key: LocalStorageKey): void {
    window.localStorage.removeItem(key);
  }

  clearStorage(): void {
    window.localStorage.clear();
  }
}
